import { AWRCData, AWRCParameters, AWRCParsedStreamData, AWRCRareStreamData } from "../../types";
import { G } from "../LogerServices";

G.AWRC_COUNT = {
    GRAPHQL: 0,
    IOTCORE: 0
}

G.SHOW_COUNT = () => {
    console.log('Liczba wygenerowanych wiadomości: ')
    console.log('AWRC IoTCore: ', G.AWRC_COUNT.IOTCORE)
    console.log('AWRC GraphQL: ', G.AWRC_COUNT.GRAPHQL)
}


export const count = (type: 'GRAPHQL' | 'IOTCORE' ) => {
    ++G.AWRC_COUNT[type]
}

export const mergeFCORBRInToOneParam = (data: AWRCRareStreamData): AWRCRareStreamData => {
    return Object.entries(data).reduce((acc, [key, val]: [string, string]) => {
        const solutionType = key.substr(0, key.indexOf('_'));
        if (['FC', 'BR', 'OR'].includes(solutionType)) {
            return Object.assign(acc, { [key.replace(solutionType, 'BR')]: val })
        }
        return Object.assign(acc, { [key]: val });
    }, {});
};

export const parseAWRCData = (data: AWRCRareStreamData): AWRCData => {
    return Object.entries(data).reduce((acc, [key, val]: [string, string]) => {
        if (key === 'LastBatchPressed') {
            return Object.assign(acc, { [key]: val === 'false' ? false : true })
        }
        return Object.assign(acc, { [key]: val === '-' || val === '' ? '-' : parseFloat(val) });
    }, {} as AWRCData)
};

export const setGroupedData = (data: any): AWRCParsedStreamData => {
    const newData = data ? data : {};
    const setDataByParams = (name: string) => ({
        waterRatioHistory: newData[`${name}_WaterRatioHist`],
        waterRatioSp: newData[`${name}_WaterRatioSp`],
        ovSP: newData[`${name}_OvSp`],
        ovAvg: newData[`${name}_OvAvg`],
        lastBatch: newData[`LastBatch${name}_WaterRatioSp`],
    });

    return {
        BU: setDataByParams(AWRCParameters.BU),
        BR: setDataByParams(AWRCParameters.BR),
        LastBatchPressed: newData.LastBatchPressed,
        FtdInletOvAverage: newData.FtdInletOvAverage,
        FtdInletOvSp: newData.FtdInletOvSp,
    }
};